<div *ngIf="quality && scheme" class="sustainable-input" [class.compact]="compact">
  <div *ngIf="!compact; else compactToggle" class="checkbox flex-center-distributed">
    <div>
      <input
        type="checkbox"
        class="ios"
        id="{{ name }}"
        [disabled]="disabled"
        [ngModel]="quality.sustainable"
        (ngModelChange)="toggle($event)"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
    <label for="{{ name }}" class="grow">{{
      "ORDER_FORM.PRODUCT.SUSTAINABLE" | translate
    }}</label>
  </div>
  <ng-template #compactToggle>
    <label class="compact-toggle small">
      <input
        type="checkbox"
        id="{{ name }}"
        [disabled]="disabled"
        [ngModel]="quality.sustainable"
        (ngModelChange)="toggle($event)"
        [ngModelOptions]="{ standalone: true }"
      />
      {{ "ORDER_FORM.PRODUCT.SUSTAINABLE" | translate }}
    </label>
  </ng-template>
  <div class="scheme" *ngIf="quality.sustainable">
    <label *ngIf="!compact" for="{{ name }}_scheme" class="control-label">{{ scheme.name }}</label>
    <select
      class="form-control"
      [class.input-sm]="compact"
      id="{{ name }}_scheme"
      [attr.aria-label]="scheme.name"
      [title]="scheme.name"
      [disabled]="disabled"
      [compareWith]="compareId"
      [(ngModel)]="quality.sustainable_scheme"
      [ngModelOptions]="{ standalone: true }"
    >
      <option *ngIf="scheme.empty" [ngValue]="scheme.empty">{{ scheme.empty.name }}</option>
      <option *ngFor="let option of options" [ngValue]="option">{{ option.name }}</option>
    </select>
  </div>
</div>
